export { default } from './MiniProfileIdentity';
